(function(app) {

    app.provider("carrierApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(carrierId) {
                            return crmApiGateway.get("/Carriers/" + carrierId);
                        }

                        service.getCarriers = function() {
                            return crmApiGateway.getArray("/Carriers");
                        }

                        service.create = function(carrier) {
                            return crmApiGateway.post("/Carriers", carrier);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line